import React, { ReactNode, ComponentType } from 'react';

import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import {
  getOrCreateGlobalContext,
  useContextWithValidation,
} from '@adsk/alloy-react-context';

type CurrentProjectIdContextValue = {
  projectId?: string;
};

/**
 * Context for current project ID.
 */
const CurrentProjectIdContext =
  getOrCreateGlobalContext<CurrentProjectIdContextValue>(
    CONTEXT_NAMES.CurrentProjectIdContext,
  );

const useCurrentProjectIdContext = () =>
  useContextWithValidation(CurrentProjectIdContext, {
    hook: 'useCurrentProjectIdContext',
    provider: 'CurrentProjectIdProvider',
  });

export const useCurrentProjectId = () => {
  const currentProjectIdContext = useCurrentProjectIdContext();
  return currentProjectIdContext?.projectId;
};

type CurrentProjectIdProviderProps = {
  projectId?: string;
  children: ReactNode;
};

export const CurrentProjectIdProvider: ComponentType<
  CurrentProjectIdProviderProps
> = ({ children, projectId }) => {
  return (
    <CurrentProjectIdContext.Provider value={{ projectId }}>
      {children}
    </CurrentProjectIdContext.Provider>
  );
};

CurrentProjectIdProvider.displayName = 'CurrentProjectIdProvider';
